import env from './env.json';

function envWithGlobals(_env) {
	const globals = {};

	['awsAccessKey', 'awsBucketName', 'host'].map(function(global) {
		if (window[global] && window[global] !== '') {
			globals[global] = window[global];
		}
	});

	return {
		...env,
		...globals
	};
}

export default envWithGlobals(env);



// WEBPACK FOOTER //
// ./src/config.js